var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSellingLands({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10674",
    "data-name": "Group 10674",
    transform: "translate(-199.419 -662.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10235",
    "data-name": "Path 10235",
    d: "M-7590.194-21786.561h12.025a.766.766,0,0,1,.582.268l12.979,15.135a.766.766,0,0,1-.08,1.078l-15.595,13.494a.761.761,0,0,1-1.012-.006l-21.816-19.469a.773.773,0,0,1-.255-.607.77.77,0,0,1,.311-.582l12.406-9.162A.779.779,0,0,1-7590.194-21786.561Zm11.672,1.531h-11.42l-11.445,8.453,20.611,18.391,14.508-12.557Z",
    transform: "translate(7833.167 22508.48)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10236",
    "data-name": "Path 10236",
    d: "M-7597.668-21816.336a.768.768,0,0,1,.529.211l15.062,14.391a.775.775,0,0,1,.236.557v8.611a.765.765,0,0,1-.767.764h-11.817l-11.541,9.092a.769.769,0,0,1-.972-.018l-14.056-11.986a.762.762,0,0,1-.27-.574.765.765,0,0,1,.257-.58l22.829-20.273A.765.765,0,0,1-7597.668-21816.336Zm14.295,15.486-14.314-13.68-21.642,19.219,12.908,11,11.256-8.861a.775.775,0,0,1,.475-.164h11.317Z",
    transform: "translate(7820.682 22512.457)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_60",
    "data-name": "Subtraction 60",
    d: "M15.991,23.718a.756.756,0,0,1-.519-.2L.247,9.547A.767.767,0,0,1,0,8.973.777.777,0,0,1,.264,8.4L9.972,0a6.052,6.052,0,0,0,.346,1.728L1.916,9l14.17,13,14.154-8.359L18.218,2.9a5.725,5.725,0,0,0,.674-1.453L32.046,13.2a.772.772,0,0,1-.12,1.235l-15.548,9.18A.748.748,0,0,1,15.991,23.718Z",
    transform: "translate(235.902 668.111)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10238",
    "data-name": "Path 10238",
    d: "M-7555.586-21810.07a.764.764,0,0,1,.5.188l16.959,14.8a.76.76,0,0,1,.262.563.768.768,0,0,1-.245.574l-19.689,18.289a.76.76,0,0,1-.521.2h-.042a.769.769,0,0,1-.538-.262l-13.077-15.141a.76.76,0,0,1-.187-.5v-8.77a.768.768,0,0,1,.381-.664l15.806-9.18A.759.759,0,0,1-7555.586-21810.07Zm15.815,15.586-15.9-13.879-14.95,8.684v8.043l12.371,14.32Z",
    transform: "translate(7838.279 22505.426)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10648",
    "data-name": "Group 10648",
    transform: "translate(232.36 683.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.721,
    cy: 20.721,
    rx: 20.721,
    ry: 20.721,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.721,
    cy: 20.721,
    rx: 20.221,
    ry: 20.221,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10647",
    "data-name": "Group 10647",
    transform: "translate(6.475 8.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M82.75,321.555l-.988-.733a1.672,1.672,0,0,0-1-.341H79.279a2.878,2.878,0,0,0-.9.144L73.9,322.114a1.751,1.751,0,0,0-1.055,1.211l-3.94-2.639a1.292,1.292,0,0,0-1.055-.216,1.273,1.273,0,0,0-.392.159,1.714,1.714,0,0,0-.666.769,2.289,2.289,0,0,0-.205.956,2.026,2.026,0,0,0,.767,1.661l7.062,5.232a1.674,1.674,0,0,0,1.021.36H80.9a1.612,1.612,0,0,0,.713-.168l1.138-.557v.725h3.879V320H82.75Zm-1.423,6.99a.972.972,0,0,1-.427.1H75.434a1.008,1.008,0,0,1-.618-.22l-7.071-5.238a1.017,1.017,0,0,1-.386-.834,1.16,1.16,0,0,1,.1-.48.855.855,0,0,1,.333-.381.637.637,0,0,1,.194-.078.663.663,0,0,1,.149-.017.651.651,0,0,1,.38.125l4.272,2.859c0,.029,0,.058.011.087a1.651,1.651,0,0,0,1.5,1.422,3.156,3.156,0,0,0,.639-.141l4.03-1.335-.2-.928-4.017,1.329c-.177.05-.405.108-.452.113a.822.822,0,0,1-.75-.707,1.069,1.069,0,0,1-.023-.178s0-.116,0-.157a.942.942,0,0,1,.571-.847l4.478-1.483a2.224,2.224,0,0,1,.7-.114h1.487a1,1,0,0,1,.6.2l1.387,1.028v5.174Zm2.2-7.584h2.327v7.685H83.526Zm0,0",
    transform: "translate(-58.002 -305.698)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M17.206,3.789,14.968,1.248A3.519,3.519,0,0,0,12.313,0H7.068a1.9,1.9,0,0,0-.933.25L5.2.781A1.115,1.115,0,0,1,4.6.93L4.172.913V0H0V10.421H4.172V9h.709l.252.189a4.234,4.234,0,0,0,2.376.868v6.048H25.03V3.789ZM3.337,9.473H.834V.947h2.5ZM5.6,8.4l-.464-.349H4.172V1.86l.393.016a1.888,1.888,0,0,0,1.009-.248L6.508,1.1a1.133,1.133,0,0,1,.561-.15h5.245a2.737,2.737,0,0,1,2.065.971l1.648,1.871H12.584L11.571,2.64l-.59.67,2.947,3.346a1.043,1.043,0,0,1,0,1.343.768.768,0,0,1-1.183,0L10.286,5.207l-.292.284a2.012,2.012,0,0,1-2.812.047L6.94,5.316l-.526.736.244.225a2.965,2.965,0,0,0,.85.544V9.11A3.466,3.466,0,0,1,5.6,8.4Zm5.934-.443.629.715a1.542,1.542,0,0,0,2.357,0,2.61,2.61,0,0,0,.549,3.253,1.947,1.947,0,0,0,2.887-.474,2.63,2.63,0,0,0-.286-3.3,1.936,1.936,0,0,0-2.913.174,2.083,2.083,0,0,0,.137-1.7h5.586A2.7,2.7,0,0,0,22.527,8.96v1.973a2.7,2.7,0,0,0-2.051,2.329H12.063a2.7,2.7,0,0,0-2.051-2.329V8.96a2.447,2.447,0,0,0,1.517-1Zm3.489,1.99A1.344,1.344,0,0,1,16.27,8.526a1.344,1.344,0,0,1,1.252,1.421,1.344,1.344,0,0,1-1.252,1.421A1.344,1.344,0,0,1,15.018,9.947ZM24.2,15.158H8.343V7.019a2.76,2.76,0,0,0,1.877-.545l.712.808a1.61,1.61,0,0,1-1.337.77H9.178v3.79h.417a1.793,1.793,0,0,1,1.669,1.895v.474H21.276v-.474a1.793,1.793,0,0,1,1.669-1.895h.417V8.052h-.417a1.793,1.793,0,0,1-1.669-1.895V5.684H14.252l-.834-.947H24.2Zm0,0",
    transform: "translate(0 0)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(278.501 704.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-2",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(245.885 662.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-2",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-2",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-2",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-2",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-2",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-2",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(247.288 730.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-3",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-3",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-3",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-3",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-3",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-3",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-4",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(212.395 706.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-4",
    "data-name": "Group 10671",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-4",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-4",
    "data-name": "Path 10240",
    d: "M80.769,0a4.77,4.77,0,0,0-4.057,7.277l3.786,6.1a.4.4,0,0,0,.338.188h0a.4.4,0,0,0,.338-.193l3.689-6.16A4.77,4.77,0,0,0,80.769,0Zm3.414,6.8-3.354,5.6L77.388,6.858a3.977,3.977,0,1,1,6.8-.054Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-4",
    "data-name": "Group 10673",
    transform: "translate(2.385 2.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-4",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-4",
    "data-name": "Path 10241",
    d: "M168.385,90a2.385,2.385,0,1,0,2.385,2.385A2.387,2.387,0,0,0,168.385,90Zm0,3.98a1.6,1.6,0,1,1,1.592-1.6A1.6,1.6,0,0,1,168.385,93.98Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellingLands);
export default __webpack_public_path__ + "static/media/sellingLands.d1aa4d2d3e80db6c72a765c21ae80772.svg";
export { ForwardRef as ReactComponent };